var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-main"},[_c('Header'),_c(_vm.pageComp,{tag:"component"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloudy-pg1"},[_c('img',{attrs:{"src":require("@/assets/cloudy.png")}})])
}]

export { render, staticRenderFns }